import { useCallback, useContext } from 'react';
import { ListingType } from 'models/Listing';
import { getCreateDealRoute, getCreateListingRoute } from 'utils';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';

const useGetListingRedirectUrl = () => {
  const { hasEnterprise } = useContext(CurrentUserContext);

  return useCallback(
    (
      dealId: string,
      listingId?: string,
      type?: ListingType,
      hasListingIm?: boolean,
    ) =>
      hasEnterprise
        ? hasListingIm
          ? getCreateDealRoute(dealId, true, 'im-upload-successful')
          : getCreateDealRoute(dealId, true, 'market-listing')
        : getCreateListingRoute(dealId, listingId, type),
    [hasEnterprise],
  );
};

export default useGetListingRedirectUrl;
